import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getPowerGenerationMaintenanceList,
	addNewPowerGenerationMaintenance,
	updatePowerGenerationMaintenance,
	deletePowerGenerationMaintenance,
	getPowerGenerationMaintenance,
} from '../powerGenerationMaintenance/thunk';

export const initialState = {
	itemPowerGenerationMaintenanceList: [],
	itemPowerGenerationMaintenanceDetail: null,
	isPowerGenerationMaintenanceLoading: false,
	isPowerGenerationMaintenanceSuccess: false,


	powerGenerationMaintenanceList: [],
	powerGenerationMaintenanceListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,

	isLoading: false,
	isSuccess: false,
	isError: false,
	error: ""
};

const PowerGenerationMaintenanceSlice = createSlice({
	name: 'PowerGenerationMaintenance',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getPowerGenerationMaintenance.fulfilled, (state, action) => {
			state.isPowerGenerationMaintenanceLoading = false;
			state.isPowerGenerationMaintenanceSuccess = true;
			state.itemPowerGenerationMaintenanceDetail = action.payload;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = true;
		});
		builder.addCase(getPowerGenerationMaintenance.pending, state => {
			state.isPowerGenerationMaintenanceLoading = true;
			state.isPowerGenerationMaintenanceSuccess = null;
			state.error = null;
			state.isLoadingList = true;
			
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getPowerGenerationMaintenance.rejected, (state, action) => {
			state.isPowerGenerationMaintenanceLoading = false;
			state.isPowerGenerationMaintenanceSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});

		builder.addCase(getPowerGenerationMaintenanceList.pending, state => {
			state.isPowerGenerationMaintenanceSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getPowerGenerationMaintenanceList.fulfilled, (state, action) => {
			state.itemPowerGenerationMaintenanceList = action.payload;
			state.powerGenerationMaintenanceList = action.payload;
			state.isLoadingList = false;
			state.isPowerGenerationMaintenanceSuccess = true;

			let powerGenerationMaintenanceListSelect = [];
			action.payload.map(item =>
				powerGenerationMaintenanceListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.powerGenerationMaintenanceListSelect = powerGenerationMaintenanceListSelect;
		});
		builder.addCase(getPowerGenerationMaintenanceList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isPowerGenerationMaintenanceSuccess = true;
		});
		builder.addCase(addNewPowerGenerationMaintenance.fulfilled, (state, action) => {
			state.itemPowerGenerationMaintenanceList.push(action.payload);
			state.powerGenerationMaintenanceList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewPowerGenerationMaintenance.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewPowerGenerationMaintenance.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updatePowerGenerationMaintenance.fulfilled, (state, action) => {
			state.itemPowerGenerationMaintenanceList = state.itemPowerGenerationMaintenanceList.map(powerGenerationMaintenance =>
				powerGenerationMaintenance.powerGenerationMaintenancename === action.payload.old_powerGenerationMaintenance
					? { ...powerGenerationMaintenance, ...action.payload.updated_powerGenerationMaintenance }
					: powerGenerationMaintenance
			);
			state.powerGenerationMaintenanceList = state.powerGenerationMaintenanceList.map(powerGenerationMaintenance =>
				powerGenerationMaintenance._id.toString() === action.payload._id.toString()
					? { ...powerGenerationMaintenance, ...action.payload }
					: powerGenerationMaintenance
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updatePowerGenerationMaintenance.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updatePowerGenerationMaintenance.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deletePowerGenerationMaintenance.fulfilled, (state, action) => {
			state.itemPowerGenerationMaintenanceList = current(state.itemPowerGenerationMaintenanceList).filter(
				item => item._id !== action.payload._id
			);
			state.powerGenerationMaintenanceList = current(state.powerGenerationMaintenanceList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deletePowerGenerationMaintenance.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deletePowerGenerationMaintenance.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
		
	},
});

export const { setRequireCloseModal } = PowerGenerationMaintenanceSlice.actions;

export default PowerGenerationMaintenanceSlice.reducer;
